import React from 'react';

const ContactSection = ({ title = "", subTitle = "", backgroundImage = "", highlightWord }) => {
  const highlightTitle = () => {
    if (highlightWord && title.includes(highlightWord)) {
      const parts = title.split(highlightWord);
      return (
        <>
          {parts[0]}
          <span className="text-cyan-400">{highlightWord}</span>
          {parts[1]}
        </>
      );
    }
    return title;
  };

  return (
    <div
      className="w-full h-[300px] sm:h-[400px] md:h-[600px] bg-contain sm:bg-cover bg-center bg-no-repeat flex items-start justify-start px-6 sm:px-10 md:pl-52 pt-[100px] sm:pt-[120px] md:pt-[140px]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="text-white max-w-3xl">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight mb-4">
          {highlightTitle()}
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl font-light leading-snug">
          {subTitle}
        </p>
      </div>
    </div>
  );
};

export default ContactSection;
